// 商品カード横スクロール — Splide 共通（cm-journal-list からも mount/destroy を参照）

function mountCardProductSlide(root) {
  if (!root || root.dataset.splideMounted === 'true' || typeof Splide === 'undefined') return;

  const splide = new Splide(root, {
    type: 'slide',
    fixedWidth: '270px',
    gap: '40px',
    arrows: true,
    pagination: false,
    perMove: 1,
    drag: true,
    i18n: window.cmSplideI18n || {},
    breakpoints: {
      767: {
        fixedWidth: '160px',
        gap: '16px',
        arrows: false,
      },
    },
  });

  splide.mount();
  root.dataset.splideMounted = 'true';
  root.splideInstance = splide;
}

function destroyCardProductSlide(root) {
  if (!root?.splideInstance) return;

  root.splideInstance.destroy();
  delete root.splideInstance;
  delete root.dataset.splideMounted;
}

function initCardProductSlides(container = document) {
  container.querySelectorAll('[data-cm-card-product-slide]').forEach(mountCardProductSlide);
}

function destroyCardProductSlides(container = document) {
  container.querySelectorAll('[data-cm-card-product-slide]').forEach(destroyCardProductSlide);
}

document.addEventListener('DOMContentLoaded', () => {
  initCardProductSlides();
});

document.addEventListener('shopify:section:load', (event) => {
  initCardProductSlides(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyCardProductSlides(event.target);
});

window.cmCardProductSlide = {
  mount: mountCardProductSlide,
  destroy: destroyCardProductSlide,
};
